import { MenuDataItem } from './layout'

export enum AppNames {
  Default = 'default',
  Cms = 'cms',
  Insurance = 'insurance',
  Crm = 'crm'
}

export type AppConfig = {
  key: AppNames
  path?: string
  routes?: React.ReactNode
  menu?: MenuDataItem[]
  selectedKeys?: string[]
  forceToken?: string
}

export type WithResults<T> = {
  count: number
  total_pages: number
  per_page: number
  current_page: number
  results: T[]
}

export type WithPagination<T> = {
  count: number
  next?: string | null
  previous?: string | null
  results: T[]
}

export enum AppPermissions {
  PRODUCT_GREEN_CARD = 'product_green_card',
  PRODUCT_MEDICAL_TRAVEL = 'product_medical_travel',
  PRODUCT_RCA = 'product_rca',
  PRODUCT_ACCIDENTS = 'product_accidents',
  PRODUCT_CASCO = 'product_casco',
  PRODUCT_PROPERTY = 'product_property',
  PRODUCT_CMR = 'product_cmr',
  SECTION_CUSTOMERS = 'section_customers',
  SECTION_ORDERS = 'section_orders',
  SECTION_REPORTS = 'section_reports',
  SECTION_EXTERNAL_API = 'section_external_api',
  SECTION_SETTINGS = 'section_settings',
  EDIT_INSURED_LIMIT_CONFIG = 'edit_insured_limit_config',
  SECTION_SALES = 'section_sales',
  SECTION_FINANCIAL = 'section_financial',
  CONFIRM_REFUND = 'confirm_refund',
  CONFIRM_SETTLEMENT = 'confirm_settlement',
  SALES_PANEL = 'sales_panel',
  NO_ORGANIZATION_LIMIT = 'no_organization_limit',
  MANUAL_ECEC_CREATION = 'manual_ecec_creation',
  RCA_DOCUMENTS = 'rca_documents',
  CONFIRM_BANK_TRANSFER = 'confirm_bank_transfer',
  SECTION_REGISTERS = 'section_registers',
  APPROVE_ORDER = 'approve_order',
  CHANGE_CONTRACT = 'change_contract',
  CONTRACTS_REGISTRY = 'contracts_registry',
  FISCAL_CODE_ENTITY = 'fiscal_code_entity',
  RCA_MARK_AS_DELETED = 'rca_mark_as_deleted',
  ONLINE_ORDERS = 'online_orders',
  INSPECTION = 'inspection',
  SECTION_CLAIMS = 'section_despagubiri',
  MANAGE_RESERVE_TYPES = 'manage_reserve_types',
  SECTION_CLAIM_CASE_RCAI = 'section_claim_case_rcai',
  CLAIM_CASE_RCAI_SUPERVISOR = 'claim_case_rcai_supervisor',
  CLAIM_CASE_RCAI_EXPERT = 'claim_case_rcai_expert',
  CLAIM_CASE_HEAD = 'claim_case_head',
  CLAIM_CASE_CONFIRM_PAYMENT = 'claim_case_confirm_payment',
  DIRECTOR = 'director',
  CLAIM_CASE_RCAI_OPERATOR = 'claim_case_rcai_operator',
  SECTION_CLAIM_CASE_RCAE = 'section_claim_case_rcae',
  CLAIM_CASE_RCAE_OPERATOR = 'claim_case_rcae_operator',
  CLAIM_CASE_RCAE_SUPERVISOR = 'claim_case_rcae_supervisor'
}
